// Obstruction handling for ceiling cans: detection is geometric (no type
// allowlists — robust across scanned RoomPlan objects and generated
// cabinetry). Perimeter cans nudge along their edge normal ("shift"),
// interior cans drop. Design doc 2026-08-06 §5.
const { getObjectType } = require('../fixture-types');
const { isPointInsidePolygon } = require('../geometry/pointInPolygon');
const { minDistanceToPolygonEdges } = require('./polygonMath');
const { footprintFor } = require('../geometry/objectFootprint');

const SHIFT_STEP = 0.05; // m — nudge increment while escaping a footprint

function findObstructionFootprints(objects, getCeilingYAt, C) {
  const footprints = [];
  for (const obj of objects || []) {
    if (!obj || !obj.center || !obj.dimensions) continue;
    if (obj.demoed === true) continue;
    const type = getObjectType(obj) || '';
    // lights hang at the ceiling by definition; they never block a can
    if (type.includes('light') || type.includes('chandelier')) continue;
    const bottom = obj.center.y - obj.dimensions.y / 2;
    const top = obj.center.y + obj.dimensions.y / 2;
    const ceilingY = getCeilingYAt(obj.center.x, obj.center.z);
    const isHighMount = bottom > C.HIGH_MOUNT_MIN_BOTTOM;
    const isTall = ceilingY != null && top > ceilingY - C.TALL_TOP_GAP;
    if (!isHighMount && !isTall) continue;
    footprints.push(
      footprintFor(
        { x: obj.center.x, z: obj.center.z },
        obj.dimensions.x + 2 * C.OBSTRUCTION_MARGIN,
        obj.dimensions.z + 2 * C.OBSTRUCTION_MARGIN,
        obj.rotation?.y ?? 0
      )
    );
  }
  return footprints;
}

function resolveObstructions(candidates, footprints, floorPolygon, C) {
  if (!footprints.length) return candidates;
  const blocked = (p) => footprints.some((f) => isPointInsidePolygon(p, f));
  const kept = [];
  for (const c of candidates) {
    if (!blocked(c)) {
      kept.push(c);
      continue;
    }
    if (!c.normal) continue; // interior can: drop
    for (let s = SHIFT_STEP; s <= C.MAX_SHIFT + 1e-9; s += SHIFT_STEP) {
      const p = {
        x: c.x + c.normal.x * s,
        z: c.z + c.normal.z * s,
        normal: c.normal,
      };
      if (blocked(p)) continue;
      if (!isPointInsidePolygon(p, floorPolygon)) break;
      if (minDistanceToPolygonEdges(p, floorPolygon) < C.MIN_EDGE_CLEARANCE)
        continue;
      kept.push(p);
      break;
    }
  }
  return kept;
}

module.exports = { findObstructionFootprints, resolveObstructions };
